<template>
  <div class="collection-wrapper">
    <div class="header">
      {{ $t('Congratulations!') }}
    </div>
    <div class="main">
      <!-- Case 1: Show Lucky Draw Winner (highest priority) -->
      <template v-if="!isEmpty(uncollectLuckyDraw) && uncollectLuckyDraw.luckyDrawWinner">
        <CollectionFrame :themeColor="'red'" style="width: 100%; height: 100%">
          <template v-slot:label> {{ luckyDrawAmount }} </template>
          <template v-slot:content>
            <div class="lucky-draw-content">
              <img src="@/assets/images/gift-box.webp" width="100" />
              <div class="badge-label">
                <p :lang="config.language">{{ $t('Lucky draw') }}</p>
                <p :lang="config.language">{{ $t('winner') }}</p>
              </div>
            </div>
          </template>
        </CollectionFrame>
      </template>

      <!-- Case 2: Show Instant Prize + Ticket (second priority) -->
      <template v-else-if="!isEmpty(uncollectInstantPrize)">
        <CollectionFrame :themeColor="'red'">
          <template v-slot:label> {{ instantRebate }} </template>
          <template v-slot:content>
            <img src="@/assets/images/gift-box.webp" width="100" />
          </template>
        </CollectionFrame>

        <!-- Show Ticket Collected if available -->
        <CollectionFrame :themeColor="'blue'" v-if="!isEmpty(luckyDrawTicket)">
          <template v-slot:label> {{ getBadgeType(luckyDrawTicket.jackpotTicket.color) }} </template>
          <template v-slot:content>
            <div class="lucky-draw-ticket-content">
              <div class="badge-label">
                {{ getBadgeType(luckyDrawTicket.jackpotTicket.color).split(' ')[0] }}
              </div>
              <img :src="require(`@/assets/images/${luckyDrawTicket.jackpotTicket.color}.webp`)" />
            </div>
          </template>
        </CollectionFrame>
      </template>
    </div>
    <div class="collect-btn" @click="$emit('jackpotPopup')">
      {{ $t('Claim your prize') }}
    </div>
  </div>
</template>
<script>
import CollectionFrame from '@/components/jackpot/collection-frame.vue';
import Badge from '@/components/jackpot/ticket-badge.vue';
import { mapGetters } from 'vuex';
import { findLast, isEmpty } from 'lodash';
import { formatAmount } from '@/utils/helpers';

export default {
  components: {
    CollectionFrame,
    Badge,
  },
  data: () => {
    return {
      isEmpty,
    };
  },
  computed: {
    ...mapGetters('jackpot', ['ownerLuckyDrawTickets', 'ownerInstantPrizeTickets']),
    ...mapGetters('general', ['member', 'config']),
    currencySymbol() {
      return this.member.currencySymbol;
    },
    uncollectInstantPrize() {
      return findLast(this.ownerInstantPrizeTickets, (ticket) => ticket.seenByMember === false);
    },
    uncollectLuckyDraw() {
      return findLast(this.ownerLuckyDrawTickets, (ticket) => ticket.seenByMember === false && ticket.luckyDrawWinner);
    },
    luckyDrawTicket() {
      return findLast(this.ownerLuckyDrawTickets, (ticket) => ticket.seenByMember === false);
    },
    instantRebate() {
      const amount = isEmpty(this.uncollectInstantPrize) ? 0 : this.uncollectInstantPrize.rebate;
      return `${this.currencySymbol} ${formatAmount(amount)}`;
    },
    luckyDrawAmount() {
      const amount = isEmpty(this.uncollectLuckyDraw.luckyDrawWinner)
        ? 0
        : this.uncollectLuckyDraw.luckyDrawWinner.amount;
      return `${this.currencySymbol} ${formatAmount(amount)}`;
    },
  },
  methods: {
    getBadgeType(color) {
      switch (color) {
        case 'red':
          return 'Major ticket';
        case 'green':
          return 'Minor ticket';
        case 'blue':
          return 'Mini ticket';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-wrapper {
  height: 100%;
  width: 100%;
  padding: 20px 12px;
  box-sizing: border-box;
  background-color: #0e86d4;
  background-image: url('~@/assets/images/shine-bg.webp');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  display: flex;
  align-items: center;
  flex-direction: column;

  &::before {
    content: '';
    position: absolute;
    top: -22px;
    left: 0;
    width: 100%;
    height: 32px;
    background-image: url('~@/assets/images/shine.png');
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 100%;
    height: 32px;
    background-image: url('~@/assets/images/shine.png');
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
  }

  .header {
    width: 100%;
    height: 40px;
    font-size: 26px;
    font-weight: 800;
    text-align: center;
    color: #0a2a3e;
    text-transform: uppercase;
  }

  .main {
    display: flex;
    height: 180px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    width: 100%;

    > div {
      &:first-of-type {
        margin-right: 4px;
      }

      &:last-of-type {
        margin-left: 4px;
      }

      .lucky-draw-ticket-content {
        width: 100%;
        position: relative;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .badge-label {
          position: absolute;
          font-size: 13px;
          font-weight: 600;
          color: #fff;
          z-index: 1;
          text-transform: uppercase;
          left: 20px;
          width: 60px;
          text-align: center;
        }

        img {
          width: 120px;
          max-height: 120px;
          position: absolute;
        }
      }

      .lucky-draw-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .badge-label {
          font-weight: 600;
          color: #fff;
          text-transform: uppercase;
          text-align: center;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;

          p {
            margin: 0;
          }

          p:nth-child(1) {
            font-size: 16px;

            &[lang='vn'],
            &[lang='id'],
            &[lang='es'],
            &[lang='pk'],
            &[lang='jp'],
            &[lang='kr'] {
              font-size: 12px;
            }
          }

          p:nth-child(2) {
            font-size: 32px;

            &[lang='id'],
            &[lang='es'],
            &[lang='pk'],
            &[lang='jp'],
            &[lang='kr'] {
              font-size: 24px;
            }

            &[lang='vn'] {
              font-size: 20px;
            }
          }
        }

        img {
          width: 120px;
          max-height: 120px;
          flex-shrink: 0;
        }
      }
    }
  }

  .collect-btn {
    height: 40px;
    padding: 0 1px;
    padding: 10px 21px 10px 22px;
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.4);
    background-image: linear-gradient(to bottom, #f4ea9f, #eac35a);
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #602b04;
    box-sizing: border-box;
    cursor: pointer;
  }
}
</style>
